import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import M from '@materializecss/materialize';
import { logOut, registerRoutes } from '../../../func';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import Axios from 'axios';
import { useDispatch } from 'react-redux';

const ContactModal = ({ isOpen, setIsOpen, refresh, contact, pharmacyId }) => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const modal = useRef(null);

  const initValues = () => ({
    firstName: '',
    lastName: '',
    title: '',
    phone: '',
    emailAddress: '',
    department: '',
  });

  const [values, setValues] = useState(initValues());

  const getModal = useCallback(
    () => (modal.current ? M.Modal.getInstance(modal.current) : null),
    []
  );
  const openModal = useCallback(() => getModal()?.open(), [getModal]);
  const closeModal = useCallback(() => getModal()?.close(), [getModal]);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          createContact: {
            func: payload => {
              Axios.post('/api/v2/pharmacycontact/create/one', {
                ...authData,
                ...payload,
              })
                .then(result => {
                  refresh();
                  dispatch(result.data);
                  closeModal();
                })
                .catch(logOut);
            },
            type: 'c',
          },
          updateContact: {
            func: payload => {
              Axios.put('/api/v2/pharmacycontact/update/one', {
                ...authData,
                ...payload,
              })
                .then(result => {
                  refresh();
                  dispatch(result.data);
                  closeModal();
                })
                .catch(logOut);
            },
            type: 'u',
          },
        },
        path
      ),
    [path, authData, dispatch, refresh, closeModal]
  );

  useLayoutEffect(() => {
    if (!modal.current) return;
    const { current } = modal;
    M.Modal.init(current, {
      onCloseEnd: () => setIsOpen(false),
      onOpenEnd: () => M.updateTextFields(),
    });

    return () => {
      M.Modal.getInstance(current)?.destroy();
    };
  }, [setIsOpen]);

  useEffect(() => {
    isOpen ? openModal() : closeModal();
  }, [isOpen, openModal, closeModal]);

  useEffect(() => {
    if (!contact) return setValues(initValues());

    setValues({
      firstName: contact.firstName,
      lastName: contact.lastName || '',
      title: contact.title || '',
      phone: contact.phone || '',
      emailAddress: contact.emailAddress || '',
      department: contact.department || '',
    });
  }, [contact]);

  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  const save = useCallback(
    e => {
      e?.preventDefault();
      if (contact)
        return networkCalls.updateContact({
          pharmacyContactId: contact.id,
          ...values,
        });
      networkCalls.createContact({
        pharmacyId,
        ...values,
      });
    },
    [contact, values, networkCalls, pharmacyId]
  );

  const cancel = e => {
    e.preventDefault();
    closeModal();
  };

  return (
    <div ref={modal} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5 className="center">{contact ? 'Edit' : 'Add'} Contact</h5>
          <div className="divider" />
        </div>
        <div className="row">
          <div className="input-field col s12 m6">
            <input
              id="firstName"
              type="text"
              value={values.firstName}
              onChange={onChange}
            />
            <label htmlFor="firstName">First Name</label>
          </div>
          <div className="input-field col s12 m6">
            <input
              id="lastName"
              type="text"
              value={values.lastName}
              onChange={onChange}
            />
            <label htmlFor="lastName">Last Name</label>
          </div>
          <div className="input-field col s12 m6">
            <input
              id="title"
              type="text"
              value={values.title}
              onChange={onChange}
            />
            <label htmlFor="title">Title</label>
          </div>
          <div className="input-field col s12 m6">
            <input
              id="department"
              type="text"
              value={values.department}
              onChange={onChange}
            />
            <label htmlFor="department">Department</label>
          </div>
          <div className="input-field col s12 m6">
            <input
              id="emailAddress"
              type="text"
              value={values.emailAddress}
              onChange={onChange}
            />
            <label htmlFor="emailAdress">Email Address</label>
          </div>
          <div className="input-field col s12 m6">
            <input
              id="phone"
              type="text"
              value={values.phone}
              onChange={onChange}
            />
            <label htmlFor="phone">Phone Number</label>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m4 offset-m4">
            <a
              href="/"
              className="btn-small blue white-text waves-effect waves-light col s12"
              onClick={save}
            >
              {contact ? 'Update' : 'Save'}
            </a>
          </div>
          <div className="col s12 m4">
            <a
              href="/"
              className="btn-small white blue-text waves effect waves-dark col s12"
              onClick={cancel}
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
